import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { cartService } from 'services';
import { RemoveLineItemParams } from 'types';
import { displayNotification } from 'utils';
import { useI18n } from 'contexts/i18n';

export const useRemoveLineItem = () => {
  const i18n = useI18n();
  const queryClient = useQueryClient();
  return useMutation(
    ({ lineItemId }: RemoveLineItemParams) => {
      return cartService.removeLineitem(lineItemId);
    },
    {
      onSuccess: (data, variables, context) => {
        displayNotification(i18n['Item successfully removed from cart']);
        queryClient.setQueriesData([ServerStateKeysEnum.userCurrentCart], data);
      },
      onError: () => {
        displayNotification(i18n['Failed to remove item from Cart!'], 'danger');
      },
    }
  );
};
